export type Pas2161ValueRagBandSlug = 'green' | 'amber' | 'red';

export interface Pas2161ValueRagBand {
  readonly slug: Pas2161ValueRagBandSlug;
  readonly label: string;
  readonly min: number;
  readonly max: number;
  readonly color: string;
}

export const PAS2161_WFS_PROPERTY_NAMES =
  'geometry,VALUE,DEFCOUNT,DEFECTNAME,CHAINAGE,OVERALLVAL,OVRDEFCT';

export const PAS2161_VALUE_RAG_BANDS: readonly Pas2161ValueRagBand[] = [
  { slug: 'green', label: 'Green', min: 0, max: 24.99, color: '#65fa00' },
  { slug: 'amber', label: 'Amber', min: 25, max: 49.99, color: '#ffbc00' },
  { slug: 'red', label: 'Red', min: 50, max: 100, color: '#ff0000' },
] as const;

export const PAS2161_VALUE_RAG_COLOR_SCHEME = {
  min: PAS2161_VALUE_RAG_BANDS[0].color,
  max: PAS2161_VALUE_RAG_BANDS[2].color,
} as const;

export const PAS2161_VALUE_RAG_THRESHOLDS = [25, 50, 100] as const;

export const PAS2161_VALUE_THRESHOLD_ATTRIBUTE = 'Severity';

export const PAS2161_VALUE_LEGEND_ITEMS = [
  { color: '#65fa00', label: '0–24.99' },
  { color: '#ffbc00', label: '25–49.99' },
  { color: '#ff0000', label: '50–100' },
] as const;
